import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { Page404Component } from './authentication/page404/page404.component';
import { AuthGuard } from './core/guard/auth.guard';
import { AuthLayoutComponent } from './layout/app-layout/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './layout/app-layout/main-layout/main-layout.component';

const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'home/dashboard', pathMatch: 'full' },
      {
        path: 'home/dashboard',
        loadChildren: () =>
          import('./dashboard/dashboard.module').then((m) => m.DashboardModule)
      },
      {
        path: 'construction',
        loadChildren: () => 
          import('./pages/modules/construction/construction.module').then(
            (m) => m.ConstructionModule
          ),
      },
      {
        path: 'notification',
        loadChildren: () => 
          import('./pages/modules/notification/notification.module').then(
            (m) => m.NotificationModule
          ),
      },
      {
        path: 'system/manage-users',
        loadChildren: () => 
          import('./pages/system/manage-users/manage-users.module').then(
            (m) => m.ManageUsersModule
          ),
      },
      {
        path: 'system/general',
        loadChildren: () => 
          import('./pages/system/general/general.module').then(
            (m) => m.GeneralModule
          ),
      },
      {
        path: 'system/payments',
        loadChildren: () => 
          import('./pages/system/payments/payments.module').then(
            (m) => m.PaymentsModule
          ),
      },
    ]
  },
  {
    path: 'authentication',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      )
  },
  { path: '**', component: Page404Component }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules, // <- comment this line for activate lazy load
      relativeLinkResolution: 'legacy',
      initialNavigation: 'enabled'  // for one load page, without reload
      // useHash: true
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
